import { z } from 'zod';

export enum RefPermissionEnum {
  ViewChatTraces = 'chat:view-traces',
  ViewQueryMetadata = 'chat:view-query-metadata',
  ApplyFilters = 'chat:apply-filters',

  BullDashboard = 'admin:bull-dashboard',
  AdminMain = 'admin:main',

  DemoMain = 'demo:main',

  AccountView = 'account.view',
  AccountManage = 'account.manage',

  AgentView = 'agent.view',
  AgentManage = 'agent.manage',

  AuthAppView = 'auth_app.view',
  AuthAppManage = 'auth_app.manage',

  AuditLogsView = 'audit_logs.view',

  BrandView = 'brand.view',
  BrandManage = 'brand.manage',

  ChatContextView = 'chat_context.view',
  ChatContextManage = 'chat_context.manage',

  ConnectedAppsView = 'connected_apps.view',
  ConnectedAppsManage = 'connected_apps.manage',

  ApplicationView = 'application.view',
  ApplicationManage = 'application.manage',

  ModuleView = 'module.view',
  ModuleManage = 'module.manage',

  DataSourceView = 'data_source.view',
  DataSourceManage = 'data_source.manage',
  // filters
  // managed-secrets
  // search
  // tools
  UnmetNeedsView = 'unmet_needs.view',
  UnmetNeedsManage = 'unmet_needs.manage',

  UserView = 'user.view',
  UserManage = 'user.manage',
  UserAssign = 'user.assign', // When assigning users to account, how does that differ from creating a user?
  NationalRep = 'national-rep',

  ApplicationAccess = 'application.access',

  FormView = 'form.view',
  FormManage = 'form.manage',

  DashboardView = 'dashboard.view',
  DashboardManage = 'dashboard.manage',

  SecretsView = 'secrets.view',
  SecretsManage = 'secrets.manage',

  CrmConnectionsView = 'crm_connections.view',
  CrmConnectionsManage = 'crm_connections.manage',

  DataConnectionsView = 'data_connections.view',
  DataConnectionsManage = 'data_connections.manage',

  PromptView = 'prompt.view',
  PromptManage = 'prompt.manage',

  PromptQueryLogView = 'prompt_query_log.view',
}
export const RefPermission = z.enum(RefPermissionEnum);
export type RefPermission = z.infer<typeof RefPermission>;

export enum RefRoleEnum {
  FieldUser = 'field-user',
  HomeOfficeUser = 'home-office-user',
  SalesRep = 'sales-rep',

  EndUser = 'end_user',
  DataScientist = 'data_scientist',
  SystemAdmin = 'system_admin',

  Viewer = 'viewer',
}
export const RefRole = z.enum(RefRoleEnum);
export type RefRole = z.infer<typeof RefRole>;

export function getRoleName(role: RefRoleEnum): string {
  const roleNames: Record<RefRoleEnum, string> = {
    [RefRoleEnum.FieldUser]: 'Field User',
    [RefRoleEnum.HomeOfficeUser]: 'Home Office User',

    [RefRoleEnum.SalesRep]: 'Sales Rep',

    [RefRoleEnum.EndUser]: 'End User',
    [RefRoleEnum.DataScientist]: 'Data Scientist',
    [RefRoleEnum.SystemAdmin]: 'System Admin',

    [RefRoleEnum.Viewer]: 'Viewer',
  };

  return roleNames[role] || 'Unknown Role';
}
